import { Link as RouterLink } from 'react-router-dom';
import { Link as UILink } from '@mui/joy';

export function Link(props) {
  return (
    <UILink component={RouterLink} {...props} />
  );
}
